import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';

import './index.less';

const AlertText = (props: any) => {
  return (
    <div className={'login_other_wrapper'}>
      <div className={'login_other'}>
        <div>
          <InfoCircleFilled style={{ color: '#FF7D00' }} />
        </div>
        <div>{props?.text}</div>
      </div>
    </div>
  );
};

export default AlertText;
